import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { heroSlides } from '../mock';

const HeroCarousel = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent((c) => (c + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, []);

  const go = (i) => setCurrent((i + heroSlides.length) % heroSlides.length);

  return (
    <section className="relative w-full overflow-hidden bg-gray-100">
      <div className="relative aspect-[1888/590] w-full">
        {heroSlides.map((slide, i) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
          >
            <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-black/10 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
                <div className="max-w-xl text-white">
                  <h2 className="text-2xl md:text-5xl font-bold leading-tight mb-3 drop-shadow-lg" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
                    {slide.title}
                  </h2>
                  <p className="text-sm md:text-lg mb-5 opacity-95 drop-shadow">{slide.subtitle}</p>
                  <a
                    href={slide.link}
                    className="inline-block bg-amber-500 hover:bg-amber-600 text-white font-semibold px-7 py-3 text-sm uppercase tracking-wide rounded-sm transition-colors shadow-lg"
                  >
                    {slide.cta}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}

        {/* Controls */}
        <button
          onClick={() => go(current - 1)}
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/80 hover:bg-white text-gray-900 flex items-center justify-center shadow-md transition-colors"
          aria-label="Previous"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => go(current + 1)}
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/80 hover:bg-white text-gray-900 flex items-center justify-center shadow-md transition-colors"
          aria-label="Next"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
          {heroSlides.map((_, i) => (
            <button
              key={i}
              onClick={() => go(i)}
              className={`h-2 rounded-full transition-all ${i === current ? 'w-8 bg-amber-500' : 'w-2 bg-white/70 hover:bg-white'}`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
